











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "mapTeamsLimitReminderToToast_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduledLockAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgName",
      "storageKey": null
    }
  ],
  "type": "NotifyTeamsLimitReminder",
  "abstractKey": null
};

(node ).hash = "0353fb6fbbd58f79518d4bb0918c87c1";

export default node;
